import { Tooltip } from '@ori-ui/mui';
import type { GlobalCustomersDocumentTypeDto } from '@ori/global-api-client-react';
import useTestId from '@ori/testid-generator';
import type { ReactElement, FC } from 'react';

import { StyledDivHeader, StyledHelpCircle, StyledLabel, StyledRequiredDocument } from './DocumentStyledComponents';

interface IDocumentHeaderProps {
  label?: ReactElement;
  documentType?: GlobalCustomersDocumentTypeDto;
  requiredDocument: boolean;
}

export const DocumentHeader: FC<IDocumentHeaderProps> = (props) => {
  const { documentType, label, requiredDocument } = props;
  const { getTestIdProps } = useTestId();

  const description = documentType?.description && (
    <Tooltip
      title={documentType.description}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      {...getTestIdProps('document-description-tooltip')}
    >
      <StyledHelpCircle />
    </Tooltip>
  );

  return (
    <StyledDivHeader>
      <StyledLabel>
        {label}
        {requiredDocument ? <StyledRequiredDocument>*</StyledRequiredDocument> : null}
        {description}
      </StyledLabel>
    </StyledDivHeader>
  );
};
